const filterPhotos = () => {
    // Get selected values from the checkboxes in the dropdowns
    const selectedSeries = Array.from(document.querySelectorAll('#series .filter-option:checked')).map(option => option.value);
    const selectedOrientations = Array.from(document.querySelectorAll('#orientation .filter-option:checked')).map(option => option.value);
    // const selectedSizes = Array.from(document.querySelectorAll('#sizes .filter-option:checked')).map(option => option.value);

    const photoItems = document.querySelectorAll('.store-item-wrapper');
    let visibleCount = 0;

    photoItems.forEach(item => {
        const seriesName = item.getAttribute('data-series'); 
        const orientation = item.getAttribute('data-orientation'); 

        // Determine if the item matches the selected filters
        const matchesSeries = selectedSeries.length === 0 || selectedSeries.includes(seriesName);
        const matchesOrientation = selectedOrientations.length === 0 || selectedOrientations.includes(orientation);

        // Show or hide the item based on matches
        if (matchesSeries && matchesOrientation) {
            item.style.display = 'block'; 
            visibleCount++;
        } else {
            item.style.display = 'none'; 
        }
    });

    // Update the filter results message
    const filterResults = document.getElementById('filter-results');
    
    // Only show results message if at least one checkbox is checked
    if (selectedSeries.length === 0 && selectedOrientations.length === 0) {
        filterResults.textContent = '';
    } else {
        const seriesMessage = selectedSeries.length ? selectedSeries.join(' & ') : 'All Series';
        const orientationMessage = selectedOrientations.length ? selectedOrientations.join(' & ') : 'All Orientations';
        // const sizeMessage = selectedSizes.length ? selectedSizes.join(', ') : 'All Sizes';

        filterResults.textContent = `SHOWING: ${seriesMessage} ; ${orientationMessage}`;
    }
};

// Add event listeners to checkboxes
document.querySelectorAll('.filter-option').forEach(checkbox => {
    checkbox.addEventListener('change', filterPhotos);
});

// add event to return to store from product detail page
const storeItems = document.querySelectorAll('.store-item-wrapper');

function getCurrentFilterState() {
    const selectedSeries = Array.from(document.querySelectorAll('#series .filter-option:checked')).map(option => option.value);
    const selectedOrientations = Array.from(document.querySelectorAll('#orientation .filter-option:checked')).map(option => option.value);

    return {
        series: selectedSeries,
        orientations: selectedOrientations
    };
}

storeItems.forEach(item => {
    item.addEventListener('click', () => {
        localStorage.setItem('storeScrollPosition', window.scrollY);
        localStorage.setItem('storeFilterState', JSON.stringify(getCurrentFilterState()));
        localStorage.setItem('returningFromProductPage', 'true');
    });
});

window.addEventListener('load', () => {
    const returningFromProductPage = localStorage.getItem('returningFromProductPage');
    const savedScrollPosition = localStorage.getItem('storeScrollPosition');
    const savedFilterState = localStorage.getItem('storeFilterState');

    if (!returningFromProductPage) {
        return;
    }

    if (savedFilterState) {
        const parsedState = JSON.parse(savedFilterState);

        document.querySelectorAll('.filter-option').forEach(option => {
            const parentId = option.closest('.dropdown-content')?.id;

            if (parentId === 'series') {
                option.checked = parsedState.series.includes(option.value);
            }

            if (parentId === 'orientation') {
                option.checked = parsedState.orientations.includes(option.value);
            }
        });

        // 🔑 This is your existing function
        filterPhotos();
    }

    if (savedScrollPosition) {
        window.scrollTo(0, parseInt(savedScrollPosition, 10));
    }

    // clean up so it doesn't trigger again
    localStorage.removeItem('storeScrollPosition');
    localStorage.removeItem('storeFilterState');
    localStorage.removeItem('returningFromProductPage');
});